<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6">
        <b-card class="picture-div" style="min-height:306px">
          <div v-if="loadingData" class="centered_container">
            <LoadingCard></LoadingCard>
          </div>
          <div v-else>
            <div class="container">
              <img
                :src="partData.image"
                alt="fibernode.com"
                style="max-height:250px; display:block; margin: auto"
              />
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card class="information" header="data">
          <div slot="header">
            <h5
              style="display: inline;line-height:35px"
              class="card-title mb-0"
            >
              Information
            </h5>
            <b-button
              class="primary"
              style="float:right;"
              @click="
                () =>
                  $router.push(
                    '/failure-details?part=' +
                      partParam +
                      '&model=' +
                      partData.model
                  )
              "
            >
              See Failure Details
            </b-button>
          </div>
          <div style="min-height: 200px">
            <span class="title-details">
              Model :
              <b>{{ partData.model }}</b>
            </span>
            <span class="title-details">
              Manufacturer :
              <b>{{ partData.make }}</b>
            </span>
            <span class="title-details">
              Product Type :
              <b>{{ partData.type }}</b>
            </span>
            <span class="title-details">
              Product Family :
              <b>{{ partData.family }}</b>
            </span>
            <span class="title-details">
              Product Description :
              <b>{{ partData.desc }}</b>
            </span>
            <span class="title-details">
              Manufacturer Part Number :
              <b>{{ partData.man_part }}</b>
            </span>
          </div>
        </b-card>
      </b-col>
      <ChartFailure
        v-if="!loadingData"
        size="6"
        offset="0"
        title="Failure By Part"
        type="Part"
        :part="partParam"
      />
      <ChartFailure
        v-if="!loadingData"
        size="6"
        offset="0"
        title="Failure By Designator"
        type="Designator"
        :part="partParam"
      />
      <ChartFailure
        v-if="!loadingData"
        size="6"
        offset="0"
        title="Failure By Complaint"
        type="Complaint"
        :part="partParam"
      />
      <ChartFailure
        v-if="!loadingData"
        size="6"
        offset="0"
        title="Failure By Failure"
        type="Failure"
        :part="partParam"
      />

      <ChartNormal
        v-if="!loadingData"
        size="6"
        offset="0"
        title="Active Backlog"
        chart="column"
        chartType="backlog"
        :isCity="false"
        :withDate="false"
        :withFinancial="false"
        :model="partParam"
        :modelName="partData.model"
      />
      <ChartNormal
        v-if="!loadingData"
        size="6"
        offset="0"
        title="Delivered"
        chart="column"
        chartType="shipped"
        :isCity="false"
        :withDate="true"
        :withFinancial="true"
        :model="partParam"
        :modelName="partData.model"
      />
      <ChartNormal
        v-if="!loadingData"
        size="6"
        offset="0"
        title="Beyond Economical Repair"
        chart="column"
        chartType="BER"
        :isCity="false"
        :withDate="true"
        :withFinancial="false"
        :model="partParam"
        :modelName="partData.model"
      />
      <ChartNormal
        v-if="!loadingData"
        size="6"
        offset="0"
        title="Under Warranty"
        chart="column"
        chartType="war"
        :isCity="false"
        :withDate="true"
        :withFinancial="false"
        :model="partParam"
        :modelName="partData.model"
      />
    </b-row>
  </div>
</template>

<script>
import ChartFailure from "../../../components/chart/chartFailure";
import ChartNormal from "../../../components/chart/chartNormal";
import LoadingCard from "../../../components/shared/LoadingCard.vue";

export default {
  props: ["part", "name"],
  name: "ModelProfile",
  components: {
    ChartFailure,
    ChartNormal,
    LoadingCard
  },
  data: function() {
    return {
      loadingData: true,
      loadingProps: false,
      partParam: "",
      partData: []
    };
  },
  methods: {
    fetchData(data) {
      this.loadingData = true;
      let params = {};
      params = {
        fns_part: this.part ? this.part : data
      };
      this.$http.get("api/sercomm/products/prodInfo.php", { params }).then(
        res => {
          this.partData = res.data[0];
          this.loadingData = false;
        },
        err => {
          console.log(err);
          this.loadingData = false;
        }
      );
    },
    getData() {
      this.loadingData = true;
      let params = {};
      params = {
        model: this.name
      };
      this.$http.get("api/sercomm/products/getFnsPart.php", { params }).then(
        res => {
          this.partParam = res.data.fns_part;
          this.fetchData(res.data.fns_part);
        },
        err => {
          console.log(err);
          this.loadingData = false;
        }
      );
    }
  },
  mounted() {
    if (this.part) {
      this.partParam = this.part;
      this.fetchData();
    } else {
      this.getData();
    }
  }
};
</script>

<style>
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
